import { NOTIFICATION_REDUCER_KEYS as KEYS } from '../reducers/notificationReducerKeys'

export const getNotificationsMap = state => {
  return state.getIn([KEYS.REDUCER, KEYS.BY_ID])
}

export const getNotification = id => state => {
  return state.getIn([KEYS.REDUCER, KEYS.BY_ID, id])
}
